"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerWalletContract = void 0;
const contract_1 = require("../base/contract");
const wallet_schemas_1 = require("../../schemas/customer/wallet.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.CustomerWalletContract = (0, contract_1.createContract)({
    name: 'CustomerWallet',
    baseUrl: '/wallet',
    version: '1',
    serviceModule: 'user',
    endpoints: {
        listWalletCoupons: {
            method: 'GET',
            path: '/coupons',
            body: null,
            query: wallet_schemas_1.listWalletCouponsQuerySchema,
            params: null,
            headers: null,
            response: {
                success: wallet_schemas_1.listWalletCouponsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'List wallet coupons',
                description: 'Retrieves paginated list of coupons in the user wallet, optionally filtered by merchant or status',
                tags: ['Customer', 'Wallet'],
                deprecated: false,
            },
            tests: [
                'should return paginated coupons',
                'should filter by merchantId',
                'should filter by status',
                'should return empty list for user with no coupons',
            ],
        },
        getWalletCouponDetails: {
            method: 'GET',
            path: '/coupons/:instanceId',
            body: null,
            query: null,
            params: wallet_schemas_1.getWalletCouponDetailsParamsSchema,
            headers: null,
            response: {
                success: wallet_schemas_1.getWalletCouponDetailsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Get coupon details',
                description: 'Retrieves detailed information about a specific coupon instance in the wallet',
                tags: ['Customer', 'Wallet'],
                deprecated: false,
            },
            tests: [
                'should return coupon details',
                'should return 404 for non-existent coupon',
                'should return 404 for coupon belonging to another user',
            ],
        },
    },
});
